import { useFormContext } from 'react-hook-form';
import { Stack } from '#pie/components/stack/Stack';
import {
  type CreateDataRequestDto,
  ReasonForDataRequest,
} from '#pie/internal/api/pie-bff';
import { AssetTypes } from '../fields/AssetTypes';
import { Attachment } from '../fields/Attachment';
import { ConsumptionTypes } from '../fields/ConsumptionTypes';
import { CustomerMandateFile } from '../fields/CustomerMandateFile';
import { DataRequestTo } from '../fields/DataRequestTo';
import { DataTypeNote } from '../fields/DataTypeNote';
import { DataTypes } from '../fields/DataTypes';
import { EnergyTypes } from '../fields/EnergyTypes';
import { EnergyTypesConsumption } from '../fields/EnergyTypesConsumption';
import { FileFormats } from '../fields/FileFormats';
import { LegalObligation } from '../fields/LegalObligation';
import { LegalObligationReasons } from '../fields/LegalObligationReasons';
import { Level } from '../fields/Level';
import { LevelAddress } from '../fields/LevelAddress';
import { LevelNote } from '../fields/LevelNote';
import { LevelZipCode } from '../fields/LevelZipCode';
import { PartitionLevel } from '../fields/PartitionLevel';
import { PartitionLevelAddress } from '../fields/PartitionLevelAddress';
import { PartitionLevelZipCode } from '../fields/PartitionLevelZipCode';
import { Periods } from '../fields/Periods';
import { PersonalDataLegalBasis } from '../fields/PersonalDataLegalBasis';
import { PersonalDataLegalBasisReason } from '../fields/PersonalDataLegalBasisReason';
import { PersonalDataLegalBasisReasonNote } from '../fields/PersonalDataLegalBasisReasonNote';
import { PersonalInformation } from '../fields/PersonalInformation';
import { Reason } from '../fields/Reason';

export const DataServicesFormStep1 = ({
  setNoLegalBasis,
}: {
  setNoLegalBasis: (value: boolean) => void;
}) => {
  const { watch } = useFormContext<CreateDataRequestDto>();
  const reason = watch('reason');
  const isOptimiseBulkUse = reason === ReasonForDataRequest.OptimiseBulkUse;

  if (isOptimiseBulkUse) {
    return (
      <Stack gap="md">
        <Reason />
        <DataTypeNote />
      </Stack>
    );
  }

  return (
    <Stack gap="md">
      <Reason />
      <LegalObligation />
      <LegalObligationReasons />
      <PersonalInformation />
      <PersonalDataLegalBasis setNoLegalBasis={setNoLegalBasis} />
      <PersonalDataLegalBasisReason />
      <PersonalDataLegalBasisReasonNote />
      <DataRequestTo />
      <DataTypes />
      <ConsumptionTypes />
      <EnergyTypesConsumption />
      <EnergyTypes />
      <AssetTypes />
      <DataTypeNote />
      <Level />
      <LevelAddress />
      <CustomerMandateFile />
      <LevelZipCode />
      <LevelNote />
      <PartitionLevel />
      <PartitionLevelAddress />
      <PartitionLevelZipCode />
      <FileFormats />
      <Periods />
      <Attachment />
    </Stack>
  );
};
